import type * as monacoEditor from "monaco-editor/esm/vs/editor/editor.api";

import {
  getRegexTagRanges,
  htmlTagRegex,
  isRangeWithinExistingRanges,
  translationTagRegex,
} from "@components/MonacoHtmlEditor/config/insertTranslationTagHelpers";

/* Check if the selected text is valid upon the conditions:
 * - Not an html tag, including partial highlighting
 * - Not within or an existing translation tag, including partial highlighting
 */
export const validateTranslationTagSelection = (
  selection: monacoEditor.Selection,
  editor: monacoEditor.editor.IStandaloneCodeEditor
): boolean => {
  const editorModel = editor.getModel();
  if (!editorModel) {
    return false;
  }
  const editorText = editorModel.getValue();
  const startPosition = editorModel.getOffsetAt(selection.getStartPosition());
  const endPosition = editorModel.getOffsetAt(selection.getEndPosition());

  // Need to compute these everytime because we can't access previous editor values to compare/memoize
  const htmlTagRanges = getRegexTagRanges(editorText, htmlTagRegex);
  const translationTagRanges = getRegexTagRanges(editorText, translationTagRegex);

  // Check if current selection lies within returned ranges of html tags and translation tag ranges
  return !isRangeWithinExistingRanges([startPosition, endPosition], [...htmlTagRanges, ...translationTagRanges]);
};
